module.exports = __webpack_public_path__ + "img/box_ic_2.a99c61a9.png";